import { Tuple } from "components/Shared/Interfaces"
import {
	OrganizationRequired,
	UserRequired,
} from "components/UserManagement/interfaces"
import {
	atLeastChecked,
	isEmailValidator,
	isEmptyString,
	max100Characters,
} from "../Validators/validators"
import { createFormValidation } from "../Validators/createFormValidation"

export type UserFields = keyof UserRequired

export type OrganizationFields = keyof OrganizationRequired

export const organizationValidateValues = {
	name: [isEmptyString, max100Characters],
	description: [isEmptyString, max100Characters],
	vendors: [atLeastChecked],
	plans: [atLeastChecked],
	brands: [atLeastChecked],
	categories: [atLeastChecked],
}

export const userValidateValues = {
	firstName: [isEmptyString],
	lastName: [isEmptyString],
	organization: [() => [false, ""]],
	email: [isEmptyString, isEmailValidator],
	roles: [atLeastChecked],
}

export const validateValues: Record<string, any[]> = {
	...userValidateValues,
	...organizationValidateValues,
}

export const mapData = (data: Array<any>, options: Tuple): Array<Tuple> => {
	return data.map((item: any) => ({
		name: item[options.name],
		code: item[options.code],
	}))
}

export const validateNewUserForm = createFormValidation(validateValues)
export const validateEditUserForm = createFormValidation(validateValues)
